// SSE stream parser (ported from the webapp agentApi.ts). Handles \r\n and \n line endings and
// events split across chunks. Cancellation is via the fetch AbortSignal upstream.

export async function* parseSseStream(
  body: ReadableStream<Uint8Array>,
): AsyncGenerator<{ event: string; data: string }> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let currentEvent: string | null = null;
  let currentData: string | null = null;

  try {
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      buffer = buffer.replace(/\r\n/g, '\n');

      const lines = buffer.split('\n');
      buffer = lines.pop() ?? ''; // keep the last (possibly partial) line

      for (const line of lines) {
        if (line.startsWith('event:')) {
          currentEvent = line.slice(6).trim();
        } else if (line.startsWith('data:')) {
          const raw = line.slice(5);
          const v = raw.startsWith(' ') ? raw.slice(1) : raw;
          currentData = currentData === null ? v : `${currentData}\n${v}`;
        } else if (line.trim() === '' && currentEvent !== null) {
          yield { event: currentEvent, data: currentData ?? '' };
          currentEvent = null;
          currentData = null;
        }
      }
    }
  } finally {
    reader.releaseLock();
  }
}
